import { __assign, __rest } from "tslib";
import React, { useMemo } from 'react';
import BaseViewer from './Base';
import mergeTheme from '../Themes/mergeTheme';
import baseTheme from '../Themes/Viewer/journal.scss';
var JournalViewer = function (_a) {
    var themeFromProps = _a.theme, _b = _a.fixedParagraph, fixedParagraph = _b === void 0 ? true : _b, restProps = __rest(_a, ["theme", "fixedParagraph"]);
    var theme = useMemo(function () { return mergeTheme(baseTheme, themeFromProps); }, [
        themeFromProps,
    ]);
    return (React.createElement("div", { className: 'da-editor-journal' },
        React.createElement(BaseViewer, __assign({ theme: theme, fixedParagraph: fixedParagraph }, restProps))));
};
JournalViewer.displayName = 'JournalViewer';
export default JournalViewer;
//# sourceMappingURL=Journal.js.map